/*
 |--------------------------------------------------------------------------
 | Document Ready Function
 |--------------------------------------------------------------------------
 */
$(function () {
    'use strict';

    /**
     * Passive event listeners
     * @link https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
     */
    var supportsPassive = false;
    try {
        var opts = Object.defineProperty({}, 'passive', {
            get: function () {
                supportsPassive = true;
            },
        });
    } catch (e) {}

    document.addEventListener(
        'touchstart',
        function (e) {
            //console.log(e.defaultPrevented);  // will be false
            //e.preventDefault();   // does nothing since the listener is passive
            //console.log(e.defaultPrevented);  // still false
        },
        supportsPassive ? { passive: true } : false
    );
    document.addEventListener(
        'touchmove',
        function (e) {
            //
        },
        supportsPassive ? { passive: true } : false
    );
});
